<template>
  <div class="centerCon">
    <el-dialog title="切换工程" :visible.sync="dialogTableVisible">
      <el-table :data="projList">
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="address" label="工程地址"></el-table-column>
        <el-table-column label="设置" width="150">
          <template slot-scope="scope">
            <span
              class="setProject"
              @click="toActive(scope.row.id)"
              v-if="scope.row.active == 0"
              >设为当前工程</span
            >
            <span class="lookMore" v-if="scope.row.active == 1">当前工程</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <div class="changeText">当前工程：{{ nowPro }}</div>
    <el-button
      class="changePro"
      type="primary"
      @click="openProjectSelector"
      plain
      >切换工程</el-button
    >

    <div class="progressCon" v-if="standardProject">
      <div
        :class="[index % 2 == 0 ? 'borderShow_1' : 'borderShow_2']"
        class="progressItem"
        v-for="(item, index) in proList"
        :key="index"
      >
        <span class="itemTitle">{{ item.roadName }}</span>
        <el-tooltip
              class="itemTitleShow"
              :style="{}"
              effect="dark"
              :content="item.roadName"
              placement="top-start"
              ><el-button></el-button
            ></el-tooltip>
        <span class="itemWay" v-if="item.roadWay">{{ item.roadWay }}</span>
        <span class="pile_1">{{ item.roadStartPile }}</span>
        <span class="pile_2">{{ item.roadEndPile }}</span>
        <div class="progressB"></div>
        <el-tooltip
          class="progressC"
          v-for="(i, n) in item.sectionProcesses"
          :key="n"
          :style="{
            width:
              (Math.abs(i.endMileage - i.startMileage) * 640) /
                Math.abs(item.endMileage - item.startMileage) +
              'px !important',
            left:
              i.startMileage < i.endMileage
                ? (Math.abs(i.startMileage - item.startMileage) * 640) /
                    Math.abs(item.endMileage - item.startMileage) +
                  274 +
                  'px'
                : (Math.abs(i.endMileage - item.endMileage) * 640) /
                    Math.abs(item.endMileage - item.startMileage) +
                  274 +
                  'px',
          }"
          effect="dark"
          :content="'起始桩号:' + i.startPile + '-' + '结束桩号:' + i.endPile"
          placement="top-start"
          ><el-button
            :style="{
              width:
                (Math.abs(i.endMileage - i.startMileage) * 640) /
                  Math.abs(item.endMileage - item.startMileage) +
                'px !important',
            }"
          ></el-button
        ></el-tooltip>
      </div>
    </div>
    <div class="progressCon" v-if="!standardProject">
      <div
        :class="[index % 2 == 0 ? 'borderShow_1' : 'borderShow_2']"
        class="progressItem"
        v-for="(item, index) in proList"
        :key="index"
      >
        <span class="itemTitleF">{{ item.roadName }}</span>
        <el-tooltip
              class="itemTitleShow"
              :style="{}"
              effect="dark"
              :content="item.roadName"
              placement="top-start"
              ><el-button></el-button
            ></el-tooltip>
        <div class="progressBF"></div>
        <div
          class="progressCF"
          :style="{
            width:
              (item.process/100 * 640) + 'px !important',
          }"
        ></div>
        <div class="progressT"
          :style="{left:(item.process/100 * 640) + 274 + 'px !important'}"
        >{{item.process}}%</div>
      </div>
    </div>

    <div class="search-line">
      <div class="search-form-group">
          <label class="group-label">日期</label>
          <el-date-picker
            size="medium"
            v-model="duration"
            @change="dateChange"
            type="daterange"
            range-separator="—"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>
        <el-button class="searchBtn" type="primary">确认</el-button>
      <div class="search-form-group">
        <label class="group-label">显示周期</label>
        <el-radio-group v-model="period" size="medium" @change="periodChange">
          <el-radio-button label="0">按日</el-radio-button>
          <el-radio-button label="1">按周</el-radio-button>
          <el-radio-button label="2">按月</el-radio-button>
        </el-radio-group>
      </div>
      
    </div>
    <Chart :processDate="processDate" :timeDate="timeDate" :workType="workType"/>
    <Daily :projectId="projectId" />
  </div>
</template>

<script>
import { getEnginList, activeEngin, getAllLayerProcess,getDateProcess,getDateTime } from "../../utils/api";
import Chart from "../quality/part/chartEn";
import Daily from "../quality/part/daily";
import { dateFormat } from "../../utils/commons.js";
export default {
  name: "app",
  data() {
    return {
      dialogTableVisible: false,
      projList: [],
      projectId: "",
      nowPro: "",
      proList: [],
      standardProject: "",
      arrowList: [
        {
          name: "工程中心",
          path: "/transfer/engineeringCenter",
        },
        {
          name: "工程进度",
          path: "",
        },
      ],
      period: 0,
      duration: '',
      workType: 4,
      processDate: {},
      timeDate: {},
      startDate:'',
      endDate:'',
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    console.log(this.$route.params.id)
    this.projectId = this.$route.params.id || ''
    if(this.projectId){
      this.toActive(this.projectId)
    }else{
      this.getProjectList();
    }
    
  },
  methods: {
    periodChange(e){
      console.log(e)
      this.period = e
      this.getProjectInfo()
    },
    dateChange(e){
      console.log(e)
      if(e == null){
        this.startDate = ''
        this.endDate = ''
      }else{
        this.startDate = dateFormat(e[0], "YYYY-MM-DD");
        this.endDate = dateFormat(e[1], "YYYY-MM-DD");
      }
      this.getProjectInfo()
    },
    getProjectInfo(){
      let params = {
        mode: this.period,
        projectId: this.projectId,
        startDate: this.startDate,
        endDate: this.endDate,
      }
      getDateProcess(params).then(res=> {
        //console.log(res)
        this.processDate = res.data.content.info
      })
      getDateTime(params).then(res=> {
        this.timeDate = res.data.content.info
      })
    },
    openProjectSelector() {
      this.dialogTableVisible = true;
      // this.getProjectList();
    },
    toActive(setId) {
      let params = {
        id: setId,
      };
      activeEngin(params).then(() => {
        this.getProjectList();
      });
    },
    getProjectList() {
      getEnginList({ pageSize: 1000 }, { listKey: "list" }).then((res) => {
        this.projList = res.data.content.info.list;
        const currentProject = (this.projList || []).find(
          (item) => item.active == 1
        );
        this.projectId = currentProject.id;
        this.nowPro = currentProject.name;
        this.$store.commit("setProjectId", this.projectId);
        // getWorks({projectId: this.projectId}).then((res) => {
        //   this.workId  = res.data.content.info.list[0].id;
        //   this.workName  = res.data.content.info.list[0].name;

        // });
        getAllLayerProcess({ projectId: this.projectId }).then((res) => {
          console.log(res);
          this.standardProject = res.data.content.info.standardProject;
          this.workType = this.standardProject?4:2
          this.proList = this.standardProject
            ? res.data.content.info.standardProjectLayerProcessVoList
            : res.data.content.info.nonStandardProjectLayerProcessVoList;
          this.getProjectInfo()
        });
        
      });
    },
  },
  components: {
    Chart,
    Daily
  },
};
</script>

<style lang="scss" scoped="">
.centerCon {
  min-height: 500px;
  width: 1872px;
  border-radius: 2px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  margin: 0 auto;
  position: relative;
  .progressCon {
    width: 100%;
    display: flex;
    height: auto;
    flex-direction: row;
    flex-wrap: wrap;
    .progressItem {
      width: 50%;
      height: 104px;
      position: relative;
      .pile_1 {
        display: inline-block;
        position: absolute;
        line-height: 17px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        top: 55px;
        left: 274px;
      }
      .pile_2 {
        display: inline-block;
        position: absolute;
        line-height: 17px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.5);
        top: 55px;
        right: 22px;
      }
      .itemTitle {
        display: inline-block;
        position: absolute;
        line-height: 22px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        top: 24px;
        left: 48px;
        width: 220px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .itemTitleShow{
        display: inline-block;
        position: absolute;
        line-height: 22px;
        top: 24px;
        left: 48px;
        width: 220px;
        opacity: 0;
        z-index: 10;
        padding: 0 !important;
      }
      .itemTitleF {
        display: inline-block;
        position: absolute;
        line-height: 22px;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.8);
        top: 41px;
        left: 48px;
        width: 220px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .itemWay {
        display: inline-block;
        position: absolute;
        width: 48px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        font-size: 14px;
        color: #ffffff;
        bottom: 24px;
        left: 48px;
        background: #f56c6c;
        border-radius: 2px;
      }
      .progressB {
        position: absolute;
        width: 640px;
        height: 12px;
        background: rgba(0, 0, 0, 0.1);
        top: 32px;
        left: 274px;
      }
      .progressBF {
        position: absolute;
        width: 640px;
        height: 12px;
        background: rgba(0, 0, 0, 0.1);
        top: 46px;
        left: 274px;
      }
      .progressCF{
        height: 12px !important;
        position: absolute;
        background-color: #6dd400 !important;
        z-index: 100;
        top: 46px;
        left: 274px;
        margin: 0 !important;
        border: none !important;
        padding: 0 !important;
      }
      .progressT{
        height: 20px;
        line-height: 20px;
        position: absolute;
        color: rgba(0, 0, 0, 0.8);
        top: 24px;
        font-size: 14px;
      }
      .progressC {
        height: 12px !important;
        top: 0;
        position: absolute;
        background-color: #6dd400 !important;
        z-index: 100;
        top: 32px;
        margin: 0 !important;
        border: none !important;
        padding: 0 !important;
      }
    }
    .borderShow_1 {
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
    .borderShow_2 {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
  .changeText {
    line-height: 28px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    right: 112px;
    top: -42px;
    z-index: 500;
  }
  .changePro {
    position: absolute;
    width: 88px;
    height: 32px;
    text-align: center;
    // line-height: 30px;
    font-size: 14px;
    // background: rgba(245, 108, 108, 0.1);
    // border-radius: 2px;
    // border: 1px solid #F56C6C;
    // color: #F56C6C;
    // cursor: pointer;
    right: 0;
    top: -45px;
    z-index: 500;
  }
  .setProject {
    display: inline-block;
    font-size: 14px;
    color: #555555;
    background: rgba(238, 236, 236, 1);
    border: 1px solid rgba(196, 196, 196, 1);
    border-radius: 16px;
    padding: 4px 16px;
    cursor: pointer;
  }
  .lookMore {
    display: inline-block;
    font-size: 14px;
    color: #e24747;
    background: rgba(255, 232, 232, 1);
    border: 1px solid rgba(226, 71, 71, 1);
    border-radius: 16px;
    padding: 4px 16px;
    margin-left: 10px;
    cursor: pointer;
  }
}

.search-line {
  background: #ffffff;
  width: 98.5%;
  margin: 0 auto;
  height: 70px;
  padding: 17.5px 17px;
}
.search-line .search-form-group {
  display: inline;
  margin-left: 20px;
}
.search-line .search-form-group .group-label {
  margin-right: 5px;
  font-size: 14px;
}
.group-label{
  margin-right: 30px !important;
}
.searchBtn{
  margin-left: 30px !important;
}
</style>